import { useEffect, useRef } from 'react';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Vision from './components/Vision';
import Solutions from './components/Solutions';
import Technology from './components/Technology';
import TrackRecord from './components/TrackRecord';
import Footer from './components/Footer';

export default function HomePage() {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll('.scroll-animate');
    sections.forEach((section) => {
      if (observerRef.current) {
        observerRef.current.observe(section);
      }
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <AboutUs />
      <Vision />
      <Solutions />
      <Technology />
      <TrackRecord />
      <Footer />
    </div>
  );
}
